/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: KM-5MN7o_pvE
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import InputFormShell from "../../InputFormShell"; // plasmic-import: e3sNvwGa9YkJ/component
import ButtonPrimary from "../../ButtonPrimary"; // plasmic-import: hEgWOAymJgYc/component
import ButtonNav from "../../ButtonNav"; // plasmic-import: n-yL9NcVDVDg/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicOnboardingContainer.module.css"; // plasmic-import: KM-5MN7o_pvE/css
import image82W82YnH8E84 from "./images/image8.svg"; // plasmic-import: 2w82ynH8e_84/picture

createPlasmicElementProxy;

export const PlasmicOnboardingContainer__VariantProps = new Array(
  "container",
  "showTerms"
);

export const PlasmicOnboardingContainer__ArgProps = new Array(
  "onContainerChange",
  "showHelperText",
  "onShowTermsChange",
  "stepHeader",
  "formWrapper",
  "text2",
  "buttonsWrapper",
  "text",
  "infotextWrapper2"
);

const $$ = {};

function PlasmicOnboardingContainer__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          showHelperText: true
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "container",
        type: "writable",
        variableType: "variant",
        valueProp: "container",
        onChangeProp: "onContainerChange"
      },
      {
        path: "showTerms",
        type: "writable",
        variableType: "variant",
        valueProp: "showTerms",
        onChangeProp: "onShowTermsChange"
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootcontainer_withForm]: hasVariant(
            $state,
            "container",
            "withForm"
          ),
          [sty.rootcontainer_withText]: hasVariant(
            $state,
            "container",
            "withText"
          ),
          [sty.rootshowTerms]: hasVariant($state, "showTerms", "showTerms")
        }
      )}
    >
      <div
        data-plasmic-name={"slotOnboardingStep"}
        data-plasmic-override={overrides.slotOnboardingStep}
        className={classNames(projectcss.all, sty.slotOnboardingStep, {
          [sty.slotOnboardingStepcontainer_withForm]: hasVariant(
            $state,
            "container",
            "withForm"
          ),
          [sty.slotOnboardingStepcontainer_withTextAndButtons]: hasVariant(
            $state,
            "container",
            "withTextAndButtons"
          ),
          [sty.slotOnboardingStepcontainer_withText]: hasVariant(
            $state,
            "container",
            "withText"
          ),
          [sty.slotOnboardingStepshowTerms]: hasVariant(
            $state,
            "showTerms",
            "showTerms"
          )
        })}
      >
        <div
          data-plasmic-name={"hederWrapper"}
          data-plasmic-override={overrides.hederWrapper}
          className={classNames(projectcss.all, sty.hederWrapper, {
            [sty.hederWrappercontainer_withForm]: hasVariant(
              $state,
              "container",
              "withForm"
            ),
            [sty.hederWrappercontainer_withTextAndButtons]: hasVariant(
              $state,
              "container",
              "withTextAndButtons"
            ),
            [sty.hederWrappercontainer_withText]: hasVariant(
              $state,
              "container",
              "withText"
            )
          })}
        >
          {renderPlasmicSlot({
            defaultContents: "one step.",
            value: args.stepHeader,
            className: classNames(sty.slotTargetStepHeader)
          })}
        </div>
        <div
          className={classNames(projectcss.all, sty.freeBox__zOiWz, {
            [sty.freeBoxcontainer_withForm__zOiWz2KMrP]: hasVariant(
              $state,
              "container",
              "withForm"
            ),
            [sty.freeBoxcontainer_withTextAndButtons__zOiWzq2Fc]: hasVariant(
              $state,
              "container",
              "withTextAndButtons"
            ),
            [sty.freeBoxcontainer_withText__zOiWzXvZg]: hasVariant(
              $state,
              "container",
              "withText"
            ),
            [sty.freeBoxshowTerms__zOiWzXsiMd]: hasVariant(
              $state,
              "showTerms",
              "showTerms"
            )
          })}
        >
          <div
            data-plasmic-name={"slotFormWrapper"}
            data-plasmic-override={overrides.slotFormWrapper}
            className={classNames(projectcss.all, sty.slotFormWrapper, {
              [sty.slotFormWrappercontainer_withForm]: hasVariant(
                $state,
                "container",
                "withForm"
              ),
              [sty.slotFormWrappercontainer_withTextAndButtons]: hasVariant(
                $state,
                "container",
                "withTextAndButtons"
              ),
              [sty.slotFormWrappercontainer_withText]: hasVariant(
                $state,
                "container",
                "withText"
              )
            })}
          >
            {(hasVariant($state, "container", "withText") ? false : true)
              ? renderPlasmicSlot({
                  defaultContents: (
                    <InputFormShell
                      actionsSlot={
                        <ButtonPrimary
                          className={classNames(
                            "__wab_instance",
                            sty.buttonPrimary__bng2R
                          )}
                          type={"button"}
                        />
                      }
                      className={classNames(
                        "__wab_instance",
                        sty.inputFormShell__fHt6
                      )}
                    />
                  ),

                  value: args.formWrapper
                })
              : null}
          </div>
          <div
            className={classNames(projectcss.all, sty.freeBox__k7ZiZ, {
              [sty.freeBoxcontainer_withForm__k7ZiZ2KMrP]: hasVariant(
                $state,
                "container",
                "withForm"
              ),
              [sty.freeBoxcontainer_withTextAndButtons__k7ZiZq2Fc]: hasVariant(
                $state,
                "container",
                "withTextAndButtons"
              )
            })}
          >
            {renderPlasmicSlot({
              defaultContents: null,
              value: args.text2
            })}
          </div>
          <div
            data-plasmic-name={"slotButtonsWrapper"}
            data-plasmic-override={overrides.slotButtonsWrapper}
            className={classNames(projectcss.all, sty.slotButtonsWrapper, {
              [sty.slotButtonsWrappercontainer_withForm]: hasVariant(
                $state,
                "container",
                "withForm"
              ),
              [sty.slotButtonsWrappercontainer_withText]: hasVariant(
                $state,
                "container",
                "withText"
              ),
              [sty.slotButtonsWrappershowTerms]: hasVariant(
                $state,
                "showTerms",
                "showTerms"
              )
            })}
          >
            {renderPlasmicSlot({
              defaultContents: null,
              value: args.buttonsWrapper
            })}
          </div>
          <div
            className={classNames(projectcss.all, sty.freeBox__dFmWm, {
              [sty.freeBoxcontainer_withText__dFmWmXvZg]: hasVariant(
                $state,
                "container",
                "withText"
              )
            })}
          >
            {renderPlasmicSlot({
              defaultContents: null,
              value: args.text
            })}
          </div>
        </div>
        {(
          hasVariant($state, "container", "withText")
            ? true
            : hasVariant($state, "container", "withTextAndButtons")
              ? true
              : (() => {
                  try {
                    return $props.showHelperText;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return true;
                    }
                    throw e;
                  }
                })()
        ) ? (
          <div
            data-plasmic-name={"infotextWrapper"}
            data-plasmic-override={overrides.infotextWrapper}
            className={classNames(projectcss.all, sty.infotextWrapper, {
              [sty.infotextWrappercontainer_withTextAndButtons]: hasVariant(
                $state,
                "container",
                "withTextAndButtons"
              ),
              [sty.infotextWrappercontainer_withText]: hasVariant(
                $state,
                "container",
                "withText"
              ),
              [sty.infotextWrappershowTerms]: hasVariant(
                $state,
                "showTerms",
                "showTerms"
              )
            })}
          >
            {renderPlasmicSlot({
              defaultContents: (
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__rNggS
                  )}
                >
                  {"Helper text."}
                </div>
              ),

              value: args.infotextWrapper2
            })}
          </div>
        ) : null}
      </div>
      <div
        data-plasmic-name={"termWrapper"}
        data-plasmic-override={overrides.termWrapper}
        className={classNames(projectcss.all, sty.termWrapper, {
          [sty.termWrappercontainer_withText]: hasVariant(
            $state,
            "container",
            "withText"
          ),
          [sty.termWrappershowTerms]: hasVariant(
            $state,
            "showTerms",
            "showTerms"
          )
        })}
      >
        <div
          className={classNames(projectcss.all, sty.freeBox__xVtYo, {
            [sty.freeBoxcontainer_withText__xVtYoXvZg]: hasVariant(
              $state,
              "container",
              "withText"
            )
          })}
        >
          <div
            data-plasmic-name={"termSlotWrapper"}
            data-plasmic-override={overrides.termSlotWrapper}
            className={classNames(projectcss.all, sty.termSlotWrapper, {
              [sty.termSlotWrappercontainer_withForm]: hasVariant(
                $state,
                "container",
                "withForm"
              )
            })}
          >
            <div
              className={classNames(projectcss.all, sty.freeBox__hZqMf, {
                [sty.freeBoxcontainer_withForm__hZqMf2KMrP]: hasVariant(
                  $state,
                  "container",
                  "withForm"
                )
              })}
            >
              <ButtonNav
                className={classNames("__wab_instance", sty.buttonNav__udx4F)}
              />

              <ButtonNav
                className={classNames("__wab_instance", sty.buttonNav___1L8Gl)}
              />

              <ButtonNav
                className={classNames("__wab_instance", sty.buttonNav___4TbSi)}
                iconForButton={
                  <PlasmicImg__
                    data-plasmic-name={"img"}
                    data-plasmic-override={overrides.img}
                    alt={""}
                    className={classNames(sty.img)}
                    displayHeight={"100%"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"none"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"100%"}
                    loading={"lazy"}
                    src={{
                      src: image82W82YnH8E84,
                      fullWidth: 20,
                      fullHeight: 20,
                      aspectRatio: undefined
                    }}
                  />
                }
                shape={"globalRounding"}
                status={"normal"}
              />
            </div>
            <div
              data-plasmic-name={"text"}
              data-plasmic-override={overrides.text}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text
              )}
            >
              {
                "Last updated JULY 25, 2025.\n\n\nLorem ipsum dolor sit amet consectetur. Consequat in eget tellus lacinia varius arcu at lacus. Vitae gravida eu sed ut. Placerat sagittis vitae purus lorem dignissim semper donec commodo egestas. Cras dui ac metus enim semper dolor sed semper facilisis. \n\n\nFacilisi vel dictumst ut mi magna morbi pellentesque sed. Purus interdum nec urna at nunc. Tellus tellus nec orci praesent lectus elementum eget tortor laoreet. Consequat quam consectetur aliquet auctor nascetur nisi rhoncus nisl. Mi tellus ac arcu mauris aenean ullamcorper. Placerat placerat vitae nibh lacus. Tincidunt consequat commodo id sagittis. Risus nec et arcu amet ut lectus. Mauris convallis vitae commodo ipsum accumsan ac consectetur odio et. Ac aliquam scelerisque tellus risus mauris risus a.\n"
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "slotOnboardingStep",
    "hederWrapper",
    "slotFormWrapper",
    "slotButtonsWrapper",
    "infotextWrapper",
    "termWrapper",
    "termSlotWrapper",
    "img",
    "text"
  ],

  slotOnboardingStep: [
    "slotOnboardingStep",
    "hederWrapper",
    "slotFormWrapper",
    "slotButtonsWrapper",
    "infotextWrapper"
  ],

  hederWrapper: ["hederWrapper"],
  slotFormWrapper: ["slotFormWrapper"],
  slotButtonsWrapper: ["slotButtonsWrapper"],
  infotextWrapper: ["infotextWrapper"],
  termWrapper: ["termWrapper", "termSlotWrapper", "img", "text"],
  termSlotWrapper: ["termSlotWrapper", "img", "text"],
  img: ["img"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOnboardingContainer__ArgProps,
          internalVariantPropNames: PlasmicOnboardingContainer__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOnboardingContainer__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOnboardingContainer";
  } else {
    func.displayName = `PlasmicOnboardingContainer.${nodeName}`;
  }
  return func;
}

export const PlasmicOnboardingContainer = Object.assign(
  // Top-level PlasmicOnboardingContainer renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    slotOnboardingStep: makeNodeComponent("slotOnboardingStep"),
    hederWrapper: makeNodeComponent("hederWrapper"),
    slotFormWrapper: makeNodeComponent("slotFormWrapper"),
    slotButtonsWrapper: makeNodeComponent("slotButtonsWrapper"),
    infotextWrapper: makeNodeComponent("infotextWrapper"),
    termWrapper: makeNodeComponent("termWrapper"),
    termSlotWrapper: makeNodeComponent("termSlotWrapper"),
    img: makeNodeComponent("img"),
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicOnboardingContainer
    internalVariantProps: PlasmicOnboardingContainer__VariantProps,
    internalArgProps: PlasmicOnboardingContainer__ArgProps
  }
);

export default PlasmicOnboardingContainer;
/* prettier-ignore-end */
